
export default {
  'profileManagement.title': 'Profile Management',
  'profileManagement.save': 'Save Changes',
  'profileManagement.personal_info': 'Personal Information',
  'profileManagement.services': 'Services',
  'profileManagement.gallery': 'Gallery',
  'profileManagement.availability': 'Availability',
  'profileManagement.locations': 'Locations',
  'profileManagement.privacy': 'Privacy Settings',
  'profileManagement.verification': 'Verification',
  'profileManagement.subscription': 'Subscription',
  'profileManagement.add_photo': 'Add Photo',
  'profileManagement.delete_photo': 'Delete',
  'profileManagement.set_as_main': 'Set as Main',
  'profileManagement.services.add': 'Add Service',
  'profileManagement.services.remove': 'Remove',
  'profileManagement.locations.add': 'Add Location',
  'profileManagement.locations.remove': 'Remove',
  'profileManagement.inactive': 'Show as inactive',
  'profileManagement.hide_profile': 'Hide profile from search',
  'profileManagement.anonymous_mode': 'Anonymous Mode',
  'profileManagement.upload_image': 'Upload Image',
  'profileManagement.upload_image_success': 'Image uploaded successfully',
  'profileManagement.upload_image_error': 'Failed to upload image',
  'profileManagement.select_profile': 'Select Profile',
  'profileManagement.upload': 'Upload',
  'profileManagement.admin_tools': 'Manage Profile Images',
  'profileManagement.storage_unavailable': 'Storage unavailable',
  'profileManagement.storage_error': 'Storage error occurred',
  'profileManagement.create_buckets': 'Create storage buckets',
  'profileManagement.buckets_created': 'Storage buckets created successfully'
};
